(function () {
  function initReviewGrid(section) {
    if (section.dataset.reviewInit === 'true') return;
    section.dataset.reviewInit = 'true';

    var track = section.querySelector('[data-review-cards]');
    var dotsWrap = section.querySelector('[data-review-dots]');
    if (!track || !dotsWrap) return;

    var cards = Array.prototype.slice.call(
      track.querySelectorAll('.review-card')
    );
    if (cards.length <= 1) return;

    var dots = cards.map(function (card, index) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'review-grid__dot';
      dot.setAttribute('aria-label', 'Go to review ' + (index + 1));
      dot.addEventListener('click', function () {
        track.scrollTo({
          left: card.offsetLeft - track.offsetLeft,
          behavior: 'smooth'
        });
      });
      dotsWrap.appendChild(dot);
      return dot;
    });

    function setActive(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }
    setActive(0);

    var ticking = false;
    track.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var center = track.scrollLeft + track.clientWidth / 2;
          var nearest = 0;
          var nearestDist = Infinity;
          cards.forEach(function (card, i) {
            var cardCenter = card.offsetLeft + card.offsetWidth / 2;
            var dist = Math.abs(cardCenter - center);
            if (dist < nearestDist) {
              nearestDist = dist;
              nearest = i;
            }
          });
          setActive(nearest);
          ticking = false;
        });
      },
      { passive: true }
    );
  }

  function init() {
    document
      .querySelectorAll('[data-section-type="review-grid"]')
      .forEach(initReviewGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
